/* eslint-disable indent */

// Constant
import { nameValueOptions } from '../../utils/helperMethods';
import { MERCHANT_ADJUSTMENT_MSG } from '../../utils/constants/toastMessages';
// Actions
import {
    createAdjustmentRequest,
    createAdjustmentError,
    createAdjustmentReset,
} from '../../containers/MerchantAdjustments/redux/adjustments.actions';
import { fetchEntityListRequest } from 'containers/MerchantOnboard/redux/entity/entity.actions'; 

// Validator
import validate from './validator';

// Libraries
import { creditAdjustmentCategory, debitAdjustmentCategory } from './constants';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';

// Styles
import './adjustmentForm.scss';

// Components
import { FormElems, Alert } from '..';
import { USER_LEVEL } from 'utils/constants/commonValues';

/**
 * CreateAdjustmentForm Component
 *
 * @param {Object} props - React component props
 */

const CreateAdjustmentForm = props => {
    const {
        handleSubmit,
        actions,
        closePopup,
        adjustmentsData,
        formData,
        fetchData,
        change,
        entityData,
    } = props;
    const { createAdjustment } = adjustmentsData || {};

    const { entityList, loading } = entityData; 
    const { merchant = [] } = entityList || {};

    const [adjustmentCategoryOptions, setAdjustmentCat] = useState([]);
    const adjustmentOptions = nameValueOptions(['CREDIT', 'DEBIT']);
    const [selectedMerchant, setSelectedMerchant] = useState(null);

    /* Effect is to show the success message and reset redux error */
    useEffect(() => {
        if (createAdjustment.isSuccess) {
            closePopup();
            fetchData({ pageIndex: 1, pageSize: 10 });
            toast.info(MERCHANT_ADJUSTMENT_MSG.MERCHANT_ADJUSTMENT_CREATE);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closePopup, createAdjustment.isSuccess]);

    /* Effect to reset the redux values */
    useEffect(() => {
        // fetch the dropdown list
        actions.fetchEntityListRequest(USER_LEVEL.MERCHANT)
        // reset data
        return () => {
            actions.createAdjustmentReset();
        };
    }, [actions]);

    const resetForm = () => {
        actions.createAdjustmentReset();
    };

    /**
     * Method to handle form submit values for create adjustmnet
     * @param {object} values
     * @returns {null}
     */
    function handleFormSubmit(values) {
        const merchantName = entityList.find(
            entity => entity.entityCode === values.merchantId
        ).name;

        const request = {
            ...values,
            merchantName,
        };
        actions.createAdjustmentRequest(request);
    }

    function onChangeAdjustmentType(adjustmentType) {
        change('adjustmentCategory', '');
        if (adjustmentType === 'CREDIT') {
            setAdjustmentCat(creditAdjustmentCategory);
        } else {
            setAdjustmentCat(debitAdjustmentCategory);
        }
    }

    useEffect(() => {
        // reset error message on unmount
        return () => {
            actions.createAdjustmentError({
                isLoading: false,
                message: '',
            });
        };
    }, [actions]);

    function displayRefId() {
        const { values } = formData || {};
        const { adjustmentCategory } = values || {};
        if (
            adjustmentCategory === 'MANUAL_REFUND' ||
            adjustmentCategory === 'CHARGEBACK_REVERSAL' ||
            adjustmentCategory === 'CHARGEBACK'
        ) {
            return true;
        }

        return false;
    }

    return (
        <form
            className="create-adjustment-form"
            onChange={resetForm}
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="form-section">
                <div className="form-field adj-level">
                    <Field
                        name="merchantId"
                        data={entityList} 
                        label={"Merchant Name"}
                        labelField="name"
                        valueField="entityCode"
                        component={FormElems.DynamicSelect}
                        onSearch={(entityName) => {
                            actions.fetchEntityListRequest(USER_LEVEL.MERCHANT, {entityName});
                        }}
                        placeholder="Enter Name"
                        optionsLoading={loading}
                        searchDelay={300}
                        onSelect={(option) => setSelectedMerchant(option)} // Callback to handle selection
                        defaultOption={selectedMerchant}
                    />
                    <br></br>
                    <Field
                        name="entityCode"
                        data={entityList} 
                        label={"Merchant ID"}
                        labelField="entityCode"
                        valueField="name"
                        component={FormElems.DynamicSelect}
                        onSearch={(entityCode) => {
                            actions.fetchEntityListRequest(USER_LEVEL.MERCHANT, {entityCode});
                        }}
                        placeholder="Enter ID"
                        optionsLoading={loading}
                        searchDelay={300}
                        onSelect={(option) => setSelectedMerchant(option)} // Callback to handle selection
                        defaultOption={selectedMerchant}
                    />
                </div>
            </div>

            <div className="form-section">
                <div className="form-field adj-level">
                    <p className="label">Adjustment Type</p>
                    <Field
                        name="adjustmentType"
                        wrapperClass="buttonMode"
                        options={adjustmentOptions}
                        valueField="value"
                        labelField="name"
                        component={FormElems.Radio}
                        onChange={onChangeAdjustmentType}
                    />
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Adjustment Category</p>
                    <Field
                        name="adjustmentCategory"
                        data={adjustmentCategoryOptions}
                        label="Select Category"
                        labelField="name"
                        valueField="value"
                        component={FormElems.Select}
                        onChange={() => change('txnReferenceId', '')}
                    />
                </div>
                <div className="form-field" style={{ marginLeft: '25px' }}>
                    <p className="label">Amount</p>
                    <Field
                        name="merchantAdjAmount"
                        type="number"
                        min={0}
                        component={FormElems.Input}
                        placeholder="Enter Amount"
                    />
                </div>
            </div>
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Merchant Transaction ID</p>
                    <Field
                        name="merchantTxnId"
                        type="text"
                        component={FormElems.Input}
                        placeholder="Enter transaction Id"
                    />
                </div>
                {displayRefId() && (
                    <div className="form-field" style={{ marginLeft: '25px' }}>
                        <p className="label">
                            Merchant Transaction reference ID
                        </p>
                        <Field
                            name="txnReferenceId"
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Transaction reference ID"
                        />
                    </div>
                )}
            </div>

            <div className="form-section">
                <div className="form-field">
                    <p className="label">Remarks</p>
                    <Field
                        name="remarks"
                        type="text"
                        component={FormElems.TextArea}
                        placeholder="Enter Comment"
                    />
                </div>
            </div>

            {createAdjustment.message ? (
                <Alert>{createAdjustment.message}</Alert>
            ) : null}
            <div className="form-section action">
                <div className="cancel-btn" onClick={() => closePopup()}>
                    CANCEL
                </div>
                <div className="submit-btn">
                    <FormElems.Button
                        buttonType="primary"
                        isDisable={formData && isEmpty(formData.values)}
                        text="SUBMIT"
                    />
                </div>
            </div>
        </form>
    );
};

const mapStateToProps = ({ auth, adjustmentsData, form, entityData }) => ({
    auth,
    adjustmentsData,
    formData: form['create-adjustment'],
    entityData
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            createAdjustmentRequest,
            change,
            createAdjustmentError,
            createAdjustmentReset,
            fetchEntityListRequest
        },
        dispatch
    ),
});

CreateAdjustmentForm.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    closePopup: PropTypes.func,
    handleSubmit: PropTypes.func,
    adjustmentsData: PropTypes.object,
    formData: PropTypes.object,
    fetchData: PropTypes.func,
    change: PropTypes.func,
    entityData: PropTypes.object.isRequired,
};

export default compose(
    reduxForm({
        form: 'create-adjustment',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(CreateAdjustmentForm);
